import { useState } from 'react';
import { ConfirmationDialog, ErpDataTableV2 } from '@/components/custom/erp';
import { MauSoHoaDon, MauSoHoaDonInput } from '@/types/schemas';
import { getDataTableColumns } from './cols-definition';
import { ActionBar, FormDialog } from './components';
import { useCRUD } from '@/hooks/queries';
import { QUERY_KEYS } from '@/constants';
import { useForms } from '@/hooks';

export default function MauSoHoaDonPage() {
  const [showErrorDialog, setShowErrorDialog] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const { addItem, updateItem, deleteItem, refreshData, isLoading, data, fetchDetail } = useCRUD<
    MauSoHoaDon,
    MauSoHoaDonInput
  >({
    endpoint: QUERY_KEYS.MAU_SO_HOA_DON
  });

  const {
    showForm,
    showDelete,
    formMode,
    isCopyMode,
    selectedObj,
    selectedRowIndex,
    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useForms<MauSoHoaDon>(fetchDetail);

  const tables = [
    {
      name: '',
      rows: data,
      columns: getDataTableColumns()
    }
  ];

  const handleFormSubmit = async (data: MauSoHoaDonInput) => {
    try {
      if (formMode === 'add') {
        await addItem(data);
        handleCloseForm();
        clearSelection();
      } else if (formMode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, data);
        handleCloseForm();
        clearSelection();
      }
    } catch (error: unknown) {
      return;
    }
  };

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      <div>
        <ActionBar
          onAddIconClick={() => handleAddClick()}
          onEditIconClick={() => selectedObj && handleEditClick()}
          onDeleteIconClick={() => selectedObj && handleDeleteClick()}
          onCopyIconClick={() => selectedObj && handleCopyClick()}
          onWatchIconClick={() => selectedObj && handleViewClick()}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={isLoading}
        />
      </div>

      {showForm && (
        <FormDialog
          open={showForm}
          onClose={handleCloseForm}
          onSubmit={handleFormSubmit}
          formMode={formMode}
          initialData={formMode === 'add' && !isCopyMode ? undefined : selectedObj}
          onAddButtonClick={() => {
            handleCloseForm();
            clearSelection();
            handleAddClick();
          }}
          onEditButtonClick={() => {
            if (selectedObj) {
              handleCloseForm();
              handleEditClick();
            }
          }}
          onDeleteButtonClick={() => {
            if (selectedObj) {
              handleCloseForm();
              handleDeleteClick();
            }
          }}
          onCopyButtonClick={() => {
            if (selectedObj) {
              handleCloseForm();
              handleCopyClick();
            }
          }}
        />
      )}

      {showDelete && (
        <ConfirmationDialog
          onClose={handleCloseDelete}
          onConfirm={() => {
            deleteItem(selectedObj!.uuid);
            handleCloseDelete();
            clearSelection();
          }}
        />
      )}
    </div>
  );
}
